export type ServicePurposeType = 0 | 1;

interface IServicePurposeTypeEnum {
    NugisPaslauga: ServicePurposeType;
    Poliklinika: ServicePurposeType;

    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 0, text: 'Nugis paslauga' },
    { key: 1, text: 'Priėmimo sąrašas' }
];

export const servicePurposeType: IServicePurposeTypeEnum = {
    NugisPaslauga: 0,
    Poliklinika: 1,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        const types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
